import React, { useState, useEffect } from "react";
import "./Slider.css";

// Import images
import slide1 from "../assets/slider/slider1.jpg";
import slide2 from "../assets/slider/slider2.jpg";
import slide3 from "../assets/slider/slider3.jpg";

const slides = [
  {
    image: slide1,
    title: "Welcome to Saisree Hardwares & Electricals",
    subtitle: "Quality paints and hardware for your home"
  },
  {
    image: slide2,
    title: "Premium Electrical Supplies",
    subtitle: "High-quality wires, switches, and lighting products for safe and efficient installations"
  },
  {
    image: slide3,
    title: "Top-notch Hardwares Supplies",
    subtitle: "Tools and materials you can trust"
  }
];

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="hero-slider-container" id="home">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${index === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="hero-overlay"></div>
          <div className="hero-slide-text">
            <h1>{slide.title}</h1>
            <p>{slide.subtitle}</p>
          </div>
        </div>
      ))}

      {/* Dots */}
      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
